import lowLevelStore, { CustomizationStore } from "./store";

export const StoreCategory = {
  CSS: "css",
  LIQUID: "liquid",
  MISC: "misc",
};

class CategoryStore extends CustomizationStore {
  update(payload) {
    if (!payload) {
      this.clear();
      return;
    }
    const existing = this.values;
    this.values = { ...existing, ...payload };
  }

  get values() {
    return super.values[this.constructor.category] || {};
  }

  set values(properties) {
    super.values = { ...super.values, [this.constructor.category]: properties };
  }
}

class LiquidStore extends CategoryStore {
  static keys = ["layout", "image-set", "url"];
  static category = StoreCategory.LIQUID;

  get layout() {
    return this.values["layout"];
  }

  get imageSet() {
    return this.values["image-set"];
  }

  isEmpty() {
    const values = { ...this.values };
    delete values.url;

    return Object.values(values).every((x) => x === null);
  }
}

class CssStore extends CategoryStore {
  static keys = [
    "primary-background-color",
    "accent-color",
    "body-font",
    "heading-font",
    "image-set",
  ];
  static category = StoreCategory.CSS;

  get colors() {
    return {
      "primary-background-color": this.values["primary-background-color"],
      "accent-color": this.values["accent-color"],
    };
  }

  get fonts() {
    return {
      "heading-font": this.values["heading-font"],
      "body-font": this.values["body-font"],
    };
  }
}

class MiscStore extends CategoryStore {
  static keys = ["company", "email", "first-name", "phone", "logo", "tagline"];
  static category = StoreCategory.MISC;

  get phone() {
    return this.values["phone"];
  }

  get email() {
    return this.values["email"];
  }

  get logo() {
    return this.values["logo"];
  }
}

class CustomizationLoader {
  constructor() {
    this.organised = {
      [StoreCategory.LIQUID]: {},
      [StoreCategory.CSS]: {},
      [StoreCategory.MISC]: {},
    };
  }

  run(payload) {
    for (const [key, value] of Object.entries(payload)) {
      if (!value) continue;

      let treated = { [key]: value };

      if (LiquidStore.keys.includes(key)) {
        this.organised[StoreCategory.LIQUID] = {
          ...this.organised[StoreCategory.LIQUID],
          ...treated,
        };
      }
      if (CssStore.keys.includes(key)) {
        this.organised[StoreCategory.CSS] = {
          ...this.organised[StoreCategory.CSS],
          ...treated,
        };
      }
      if (MiscStore.keys.includes(key)) {
        this.organised[StoreCategory.MISC] = {
          ...this.organised[StoreCategory.MISC],
          ...treated,
        };
      }
    }
    lowLevelStore.values = this.organised;
  }
}

const liquid = new LiquidStore();
const css = new CssStore();
const misc = new MiscStore();

export { liquid, css, misc, CustomizationLoader };
